import { render, staticRenderFns } from "./visaMaterialesAseo.vue?vue&type=template&id=20e6ff7c&scoped=true&"
import script from "./visaMaterialesAseo.vue?vue&type=script&lang=js&"
export * from "./visaMaterialesAseo.vue?vue&type=script&lang=js&"
import style0 from "./visaMaterialesAseo.vue?vue&type=style&index=0&id=20e6ff7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6ff7c",
  null
  
)

export default component.exports